<template>
    <div class="el-container content">
        <el-dialog
                :visible.sync="dialogVisible"
                width="40%"
                :before-close="handleClose"
                center>
            <el-form ref="eventForm" :inline="false" label-width="30%" :model="data" :rules="$data.rules">
                <el-form-item :label="$t('event.editForm.fieldEventName')" prop="eventName">
                    <el-input v-model="data.eventName" :placeholder="$t('event.editForm.placeHolder.fieldEventName')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('event.editForm.fieldEventInterval')" prop="eventRange">
                    <el-date-picker
                            value-format="timestamp"
                            v-model="data.eventRange"
                            type="daterange"
                            :format="$t('common.dateFormatTemplate2')"
                            :range-separator="$t('event.editForm.placeHolder.fieldEventIntervalRangeSeparator')"
                            :start-placeholder="$t('event.editForm.placeHolder.fieldEventIntervalStart')"
                            :end-placeholder="$t('event.editForm.placeHolder.fieldEventIntervalFinish')"
                            :placeholder="$t('event.editForm.placeHolder.fieldEventInterval')">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <el-footer align="right">
                <el-button type="primary" @click="handleSave('eventForm')">{{$t('event.buttonSave')}}</el-button>
                <el-button @click="handleClose">{{$t('event.buttonClose')}}</el-button>
            </el-footer>
        </el-dialog>
    </div>
</template>

<script>
    import EventUtils from '@/api/event';
    import Utils from '@/utils';

    export default {
        name: "EventEditModal",
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                rules: {
                    eventName: [
                        {required: true, message: 'Please input Event name', trigger: 'blur'},
                        {min: 3, message: 'Length should be > 3 ', trigger: 'blur'}
                    ], eventRange: [
                        {required: true, validator: Utils.checkDateTimeRange, trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            handleClose: function () {
                this.$emit("visible-change", false);
            },
            frameLoaded: function () {
                console.log('Frame with Event edit is loaded');
            },
            handleSave: function (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = false;
                        let eventObj = {};
                        let user = JSON.parse(localStorage.getItem('user'));
                        if (this.data.id != undefined) {
                            eventObj.id = this.data.id;
                        }
                        eventObj.name = this.data.eventName;
                        eventObj.eventStart = this.data.eventRange[0];
                        eventObj.eventEnd = this.data.eventRange[1];
                        eventObj.sport = {id: 1};
                        eventObj.club = {id: user.club.id};
                        eventObj.user = {id: user.id};
                        eventObj.prefixLive = '/replyGpx/';
                        eventObj.prefixReply = '/replyGpx/';
                        eventObj.type = {id: 2};
                        console.log('Try save: ' + JSON.stringify(eventObj));
                        let eventPromis;
                        if (eventObj.id == undefined) {
                            eventPromis = EventUtils.createEvent(eventObj);
                        } else {
                            eventPromis = EventUtils.updateEvent(eventObj);
                        }
                        eventPromis.then(response => {
                            this.$emit("visible-change", false);
                            this.$emit("on-close", response.data);
                        }).catch(error => {
                            console.log("Error with creating event: " + error);
                            this.loading = false;
                            Utils.showMessage(this, "Ошибка!", "Ошибка при создании\\редактировании гонки!");
                        }).finally(() => {
                            this.loading = false;
                        });
                    } else {
                        Utils.showMessage(this, "Ошибка ввода данных", "Проверьте правильность введенных данных");
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
